import React, {useContext} from 'react';
import {Arguments} from '../common/Arguments';
import {Col, Form, Input, message, Row} from 'antd';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {convertData, PostApiMethod, PostToJava} from '../common/ApiMethod';
import {sideMenuContext} from '../../../router/IndexRouter';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';
import {aesDecrypt} from '../common/EncodeDecodeMethod';
import '../../../components/sandbox/index.css';
import {getFirstLetters} from '../common/ConversionMethod';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const ChangeUserName = () => {
		const [form] = Form.useForm();
		const {currentItem} = useContext(sideMenuContext);
		const userInfoApi = Arguments.host + '/society_organization/policy/api!addUser.do';
		const updateUserApi = Arguments.host + '/society_organization/updateUser/api!updateUserName.do';
		const organizationInfoApi = Arguments.host + '/society_organization/society/api!addSocietyInformation.do';
		const onFinish = (data) => {
			// 首先向用户中心发送修改用户信息的请求
			const ObjData = {
				userName: currentItem.userName,
				newUserName: getFirstLetters(data.newUserName),
				password: aesDecrypt(currentItem.password),
				nickname: currentItem.nickname,    // 对应用户中心的真实姓名
				token: sessionStorage.getItem('userToken'),
			};
			PostToJava(updateUserApi, ObjData).then(res => {
					if (res?.data.code === 1) {
						// 更新 user_info 表中数据
						const userData = {
							...currentItem, ...data,
							organizationName: data.newUserName,
							nickname: data.newUserName,
							userName: getFirstLetters(data.newUserName),
						};
						// console.log("userData    ", userData)
						PostApiMethod(userInfoApi, userData);
						setTimeout(() => {
							// 更新 organization_info 表中数据
							// 为了避免出现两次成功提醒，并尽可能减少对其他程序的影响，此处不使用 PostApiMethod
							const ObjData = convertData(userData);
							PostToJava(organizationInfoApi, ObjData).then(res => {
								if (res?.data.code === 1 || res?.data.code === '1') {
									// console.log("向 organization_info 表中新增数据成功");
								} else {
									// console.log("向 organization_info 表中新增数据失败：" + res.data.result.msg)
								}
							}).catch(error => {
								// console.log("error   ", error)
								message.error('新增数据失败');
							});
						}, 1500);
					} else {
						message.error('操作失败：' + res?.data.result);
					}
				},
			);
		};

		return (
			<Form
				{...layout}
				form={form}
				name="control-hooks"
				onFinish={onFinish}
				initialValues={currentItem}
				style={{maxWidth: 1200, marginLeft: 40}}
			>
				<div className="panel panel-default mt-20">
					<div className="panel-header" style={{marginBottom: 20}}>当前用户信息</div>
				</div>

				<Row align="top">
					<Col span={12}>
						<Form.Item name="nickname" label="原登录用户名"
								   rules={[{required: true, validator: validateWhiteSpace}]}>
							<Input disabled={true}/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item name="newUserName" label="新登录用户名"
								   rules={[{required: true, validator: validateWhiteSpace}]}>
							<Input placeholder={'为避免重名，请使用全称'}/>
						</Form.Item>
					</Col>
				</Row>


				<Form.Item {...tailLayout}>
					<SaveButtonComponent/>
				</Form.Item>
			</Form>
		);
	}
;

export default ChangeUserName;
